




























































































































































import Vue from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "SingleSchool",
  data() {
    return {
      school: {},
      edit: false,
      admins: [],
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: Number,
  },
  methods: {
    startEditing() {
      this.edit = true;
    },
    editSchool() {
      this.$router.push({
        name: "Edit School",
        params: { school_id: this.id },
      });
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.user.admin_type.name;
    },
  },
  mounted() {
    ApiService.sadminApi.getSchool(this.id).then((resp) => {
      this.school = resp.data;
    });
  },
});
